import orders from './Orders.module.css';
import classes from './Purchasing.module.css';

/**
 * PO kalem tablosunun toplam satırı (`satin-alma-akisi.jpeg` "Purchase Order" Items). Geniş
 * ekranda etiket sağa yaslı, tutar kendi sütununda. Telefonda (767 px altı) tablo yatay kayar ve
 * tutar sütunu ekran dışında kalır; etiket hücresi sola yaslanır, yapışkan olur ve tutarı da
 * gösterir (M12c-R21; Responsive kurallar). Tekrar eden tutar ekran okuyucudan gizlidir.
 */
export function ItemsTotalRow({
  label,
  amount,
  span,
  trailing,
}: {
  label: string;
  amount: string;
  /** Etiketin kapladığı sütun sayısı. */
  span: number;
  /** Tutardan sonraki boş sütun sayısı (teslim alınan ve açık miktar gösteriliyorsa). */
  trailing: number;
}) {
  return (
    <tr className={orders.totalRow}>
      <th scope="row" colSpan={span} className={`${orders.totalLabel} ${classes.key}`}>
        {label}
        <span className={orders.totalInline} aria-hidden="true">
          {amount}
        </span>
      </th>
      <td className={classes.nowrap}>{amount}</td>
      {trailing > 0 ? <td colSpan={trailing} /> : null}
    </tr>
  );
}
